import { IDL } from '@dfinity/candid'
import { Actor, ActorMethod } from '@dfinity/agent'
import { ExtAgent, getAgentType } from './agent'

export const createActor = async (
  canisterId,
  idl,
  agent,
) => {
  const agentType = getAgentType(agent)
  if ('identity' === agentType || 'anonymous' === agentType || 'stoic' === agentType) {
    return createInternetIdentityActor(canisterId, idl, agent)
  } else if ('plug' === agentType) {
    return createPlugActor(canisterId, idl)
  } else {
    throw new Error('UNSUPPORTED_AGENT_TYPE')
  }
}

const createInternetIdentityActor = async (
  canisterId,
  idl,
  agent,
) => {
  return Actor.createActor(idl, { canisterId, agent })
}

const createPlugActor = async (canisterId, idl) => {
  if (window.ic?.plug === undefined) {
    throw new Error('INSTALL_PLUG_TIP')
  }
  const { plug } = window.ic
  //@ts-ignore
  return await plug.createActor({ canisterId, interfaceFactory: idl })
}
